import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import im1 from "../assets/images/B1.webp";
const brands = [
  "Lenses....Zeiss",
  "Essilor",
  "Rodenstock",
  "Vision Rx",
  "Nova",
  "Kodak",
  "Vogue",
  "Tom Ford",
  "Ray-Ban",
  "Carrera",
  "Police",
  "Boss",
  "Mont Blanc",
];
export default function b1pages() {
  return (
    <>
      <Header />
      <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #d0eaff, white)",
        padding: "20px",
      }}
    >
      {/* Header Section */}
      <header style={{ textAlign: "center", marginBottom: "20px" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#000",
            marginBottom: "10px",
          }}
        >
          Keratoconus
        </h1>
        <p style={{ fontSize: "1rem", color: "gray" }}>
        Protect Your Vision &bull; Prioritize Your Eye Health
        </p>
      </header>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          maxWidth: "800px",
          width: "100%",
        }}
      >
        <img
          src={im1}
          alt="Contact lenses shop"
          style={{ width: "100%", height: "auto", borderRadius: "10px" }}
        />
      </div>
      
    </div>
    <div
      style={{
        maxWidth: "800px",
        margin: "40px auto",
        padding: "0 20px",
        fontFamily: "'Georgia', serif",
        lineHeight: "1.8",
        color: "#333",
      }}
    >
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Keratoconus
      </h1>

      <p style={{ marginBottom: "20px" }}>
      Progressive non inflammatory bilateral (85%) ectatic condition of cornea in its axis part
       Developmental condition , Degenerative condition , Hereditary , Endocrine anomaly 
      </p>
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Symptoms
      </h1>
      <p style={{ marginBottom: "20px" }}>
      Defective vision ( progressive myopia & irregular astigmatism ) 
      Image distorted with glare , Halos around lights , Light sensitivity , Ocular irritation , Itching
      </p>
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Risk Factors
      </h1>
      <p style={{ marginBottom: "20px" }}>
      Eye rubbing associated with atopy , Sleep apnea , Floppy lid syndrome 
      </p>
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Managements
      </h1>
      <p style={{ marginBottom: "20px" }}>
      To avoid eye rubbing or pressure ( sleep with the hand against the eye ) can cause or lead to the progression of Keratoconus. 
      Use preservative free topical lubricants to decrease the impulse to rub eyes, allergy medicines. 
      Spectacles - may improve vision in early cases (in later falling vision may not be corrected by glasses due to irregular astigmatism).
      Contact Lens - Soft CL , RGP , Piggy back lens , Hybrid lens , Rose K Lens.
      CL & Scleral lenses are extremely important for visual rehab in patients with Keratoconus.
      Surgery – C3R , Keratoplasty ( DALK , PK , LK ) , Intra corneal ring segment. 
      Use UV protection in the CL & Glasses  

      </p>
    </div>
      <Footer />
    </>
  );
}
